export const styles = {
  formContainer: 'tw-flex tw-flex-col tw-h-full tw-min-h-0 tw-gap-6',
  section: 'tw-flex tw-flex-col tw-gap-2',
  sectionTitle: 'tw-text-sm tw-font-medium tw-text-neutral-700',
  subOfferingsSection: 'tw-flex tw-flex-col tw-flex-1 tw-min-h-0 tw-gap-4',
  subOfferingsHeader: 'tw-flex tw-items-center tw-justify-between tw-gap-3',
  offeringRow: 'tw-flex tw-items-center tw-gap-2',
  offeringInput: 'tw-flex-1',
  listContainer:
    'tw-flex-1 tw-min-h-0 tw-overflow-y-auto tw-border tw-border-neutral-200 tw-rounded tw-p-2 tw-bg-neutral-50/50',
  list: 'tw-grid tw-grid-cols-2 tw-gap-3 tw-pl-0 tw-m-0 tw-w-full',
  addForm:
    'tw-mt-4 tw-p-4 tw-border tw-border-neutral-200 tw-rounded tw-bg-neutral-50 tw-shadow-sm',
  addFormRow: 'tw-flex tw-flex-wrap tw-items-end tw-gap-3 tw-mb-2',
  addFormField: 'tw-min-w-0 tw-flex-1',
  addFormActions: 'tw-flex tw-gap-2',
  emptyList:
    'tw-col-span-2 tw-px-4 tw-py-8 tw-text-sm tw-text-neutral-500 tw-text-center tw-bg-neutral-50 tw-rounded tw-border tw-border-neutral-100',
  clearButton:
    'tw-bg-accent-rose tw-border-transparent hover:tw-bg-accent-rose-hover tw-text-white',
  submitButton:
    'tw-bg-accent-purple tw-border-transparent hover:tw-bg-accent-purple-hover tw-text-white',
};
